const rawPrivilegesTypes =[
    {"value":"", "label":""},
    {"value": "ACTIVE", "label":"Active"},
    {"value": "ACTIVE_PROVISIONAL", "label":"Active - Provisional"},
    {"value": "APP", "label":"APP"},
    {"value": "ASSOCIATE", "label":"Associate"},
    {"value": "ASSOCIATE_ATTENDING", "label":"Associate Attending"},
    {"value": "ATTENDING", "label":"Attending"},
    {"value": "CONSULTING", "label":"Consulting"},
    {"value": "COURTESY", "label":"Courtesy"},
    {"value": "EXPIRED", "label":"Expired"},
    {"value": "HOSPITAL_AFFILIATE", "label": "Hospital Affiliate"},
    {"value": "HOSPITAL_AFFILIATE_FPPE", "label": "Hospital Affiliate - FPPE"},
    {"value": "OTHER", "label":"Other"},
    {"value": "TEMPORARY", "label":"Temporary"},
    {"value": "VOLUNTARILY_RESIGNED", "label":"Voluntarily Resigned"}
  ];

  export default rawPrivilegesTypes;
  